import React from "react";
import SectionTitleSpecial from "../../components/SectionTitle/SectionTitleSpecial";
import FaqOne from "../../components/Faq";
import shapeImg1 from "../../assets/img/choose/shape-1-1.png";
import shapeImg2 from "../../assets/img/choose/shape-1-2.png";
import shapeImg3 from "../../assets/img/choose/shape-1-3.png";
import shapeImg4 from "../../assets/img/choose/shape-1-4.png";
import members from "../../assets/img/sap/members.jpg";

const WhyChooseUs = ({ leadership, ecMembers, pastPresidents }) => {
  const sortedPastPresidents = pastPresidents.sort((a, b) => {
    return parseInt(a.from) - parseInt(b.from);
  });

  const items = [
    {
      id: "a",
      btnText: "Office Bearers",
      description:
        leadership?.map((m) => `${m.designationName} - ${m.fullName}`) || [],
    },
    {
      id: "b",
      btnText: "EC Members",
      description: ecMembers?.map((m) => m.fullName) || [],
    },
    {
      id: "c",
      btnText: "Coordinator",
      description: ["Kamalraj R"],
    },
    {
      id: "d",
      btnText: "Past Presidents",
      description:
        sortedPastPresidents?.map(
          (m) => `${m.fullName} (${m.from} - ${m.to})`
        ) || [],
    },
  ];

  return (
    <div className="it-choose-area p-relative fix pt-50 pb-50">
      <div className="it-choose-shape-4 d-none d-md-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-choose-left">
              <SectionTitleSpecial
                itemClass="it-choose-title-box mb-30"
                subTitle="SAP Leadership"
                preTitle="Meet the SAP Leadership"
                highlightText=" Team."
              />

              <div className="it-choose-text pb-15">
                <p>
                  The SAP Leadership Team guides the Society with strategic
                  vision and industry expertise. They drive initiatives that
                  support professional growth and the success of events like
                  Aqua India.
                </p>
              </div>
              <FaqOne items={items} />
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-choose-thumb-box text-center text-lg-end">
              <div className="it-choose-thumb p-relative">
                <img src={members} alt="" />
                <div className="it-choose-shape-1">
                  <img src={shapeImg1} alt="" />
                </div>
                <div className="it-choose-shape-2">
                  <img src={shapeImg2} alt="" />
                </div>
                <div className="it-choose-shape-3 d-none d-lg-block">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
